import styles from "./NotificationTooltip.module.css";
import React, { useEffect, useState } from "react";
import { Stack, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ImageAssets from "../../../assets";
import { MuiButton } from "../../../components/common/button/MuiButton";
import { FilledTabSwitcher } from "../../../components/common/tab-switcher/TabSwitcher";
import { NotificationTabEnumUtils } from "../../../core/enumerations/NotificationsTabSwitcherEnum";
import { notifications } from "../../../core/json/NotificationJson";
import routesNames from "../../../routes/RouteNames";
import strings from "../../../strings/Strings";
import { notificationsRedux } from "../../../redux/notification-redux/NotificationsRedux";
import { useDispatch, useSelector } from "react-redux";
import { getLocalStorageItem } from "../../../utils/LocalStorage";
import InfiniteScroll from "react-infinite-scroll-component";
import { CircularLoader } from "../../../components/common/loaders/CircularLoader";
import { getCookies } from "../../../utils/Cookies";

const NotificationContent = ({ onCloseNotification }) => {

  const actionDispatch = (dispatch: any) => ({
    getAllUserNotifications: (data: any) =>
      dispatch(notificationsRedux.actions.getAllUserNotificationsRequest(data)),
    updateNotification: (data: any) =>
      dispatch(notificationsRedux.actions.updateNotificationRequest(data)),
  });

  const {
    getAllUserNotifications,
    updateNotification
  } = actionDispatch(useDispatch());

  const userDetails: any = getCookies("userDetails");
  const loginUserDetails = JSON.parse(userDetails);
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState<any>(0);
  const [pageNo, setPageNo] = useState<any>(1);
  const notificationState = useSelector((state: any) => state?.notificationsRedux);
  const notificationData = notificationState?.userNotificationsData;

  const handleTabValue = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    setPageNo(1);
    getAllUserNotifications({
      userId: loginUserDetails?.id,
      pageNo: 1,
      pageSize: 20,
    });
  }, []);

  const handleChangePageNo = () => {
    console.log(notificationData?.totalPages, "notificationData?.totalPages")
    if (
      notificationData?.totalPages !== pageNo &&
      notificationData?.totalPages
    ) {
      setPageNo(pageNo + 1);
      getAllUserNotifications({
        userId: loginUserDetails?.id,
        pageNo: pageNo + 1,
        pageSize: 10,
      });
    }
  };

  function timestamps(date: Date): string {
    const seconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);
    let interval;
    interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
      return interval + "y";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      return interval + "mo";
    }
    interval = Math.floor(seconds / 604800);
    if (interval >= 1) {
      return interval + "w";
    }
    interval = Math.floor(seconds / 86400);
    if (interval >= 1) {
      return interval + "d";
    }
    interval = Math.floor(seconds / 3600);
    if (interval >= 1) {
      return interval + "h";
    }
    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
      return interval + "m";
    }
    if (seconds > 0) {
      return Math.floor(seconds) + "s";
    }
    else {
      return "now";
    }
  }

  const handleOnClick = (item) => {
    onCloseNotification(false);
    if (item?.userId) {
      navigate(`/profile/others-profile/${item?.userId}`);
    }
    else if (item?.notificationType && item?.notificationType === "PROJECT_REVIEW") {
      navigate(routesNames.endProject, {
        state: {
          projectId: item?.projectId,
          activeStep: 1
        },
      });
    }
    else if (item?.projectId) {
      navigate(routesNames?.projectDetails?.replace(":id", item?.projectId));
    }
    else if (item?.postId && item?.userId) {
      navigate(`/home/view-post/${item?.postId}/${item?.userId}`);
    }
    updateNotification(item?.id);
  }

  const renderTabContent = (tabValue: number) => {
    if (tabValue === 0) {
      return (
        <div style={{ height: '100%', overflow: 'scroll' }} id="scrollable-notifications">
          <InfiniteScroll
            dataLength={notificationData?.responseData?.length ? notificationData?.responseData?.length : 1}
            next={() => handleChangePageNo()}
            hasMore={pageNo < notificationData?.totalPages}
            loader={
              notificationState?.isLoading && (
                <Stack
                  justifyContent={"center"}
                  alignItems={"center"}
                  sx={{ width: "100%", height: "100px" }}
                >
                  <CircularLoader />
                </Stack>
              )
            }
            scrollableTarget="scrollable-notifications"
          >
            {notificationData?.responseData?.length > 0 ?
              notificationData?.responseData?.map((notification: any, notificationIndex: any) => {
                return (
                  <Stack gap={1} key={notificationIndex}>
                    <div className={styles["notification-time"]}>
                      {/* {timestamps(notification?.createdAt) || "Today"} */}
                    </div>
                    <div
                      key={notificationIndex}
                      className={
                        notification?.isViewed
                          ? styles["notification-content-read"]
                          : styles["notification-content-un-read"]
                      }
                      onClick={() => handleOnClick(notification)}
                    >
                      <img
                        className={styles["profile-image"]}
                        src={notification?.projectId ? notification?.previewImage : notification?.notifierProfile || ImageAssets.ic_dummy_profile}
                        alt={"user_image"}
                      />
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          // flexDirection: "column",
                          padding: "0px 10px",
                          width: "100%",
                          alignItems: "center"
                        }}
                      >
                        {/* <span style={{ textAlign: "left", display: "flex" }}> */}
                        {/* <span className={styles["profileName"]}>
                          {notification?.profileName}
                        </span> */}
                        <span className={styles["notification"]}>
                          {notification?.message}
                        </span>
                        {/* </span> */}
                        <span className={styles["notifiedTime"]}>
                          {timestamps(notification?.createdAt)}
                        </span>
                      </span>
                    </div>
                  </Stack>
                );
              })
              : <img style={{ height: '50%', width: '100%' }} src={ImageAssets.ic_notifications} />
            }
          </InfiniteScroll>
        </div>
      );
    } else {
      return (
        <>
          <div className={styles["tab-content"]}>
            <img
              src={
                tabValue === 1
                  ? ImageAssets.ic_notification_post
                  : tabValue === 2
                    ? ImageAssets.ic_notification_project
                    : ImageAssets.ic_notification_events
              }
              className={styles["image"]}
              alt={"notifications-icons"}
            />
          </div>
          <Typography className={styles["tab-content-text"]}>
            {tabValue === 1
              ? strings.postNotificationMessage
              : tabValue === 2
                ? strings.projectNotificationMessage
                : strings.eventNotificationMessage}
          </Typography>
          {renderButton(tabValue)}
          <div className={styles["tab-button"]}>
            <Link to={routesNames.explore} className={styles["link"]}>
              <MuiButton className={styles["mui-button"]}>
                {"Explore"}{" "}
              </MuiButton>
            </Link>
          </div>
        </>
      );
    }
  };

  const renderButton = (tabValue: number) => {
    if (tabValue === 1) {
      return (
        <div className={styles["tab-button"]}>
          <Link to={routesNames.createPost} className={styles["link"]}>
            <MuiButton className={styles["mui-button"]}>
              {strings.createPost}{" "}
            </MuiButton>
          </Link>
        </div>
      );
    } else if (tabValue === 2) {
      return (
        <div className={styles["tab-button"]}>
          <Link to={routesNames.profile} className={styles["link"]}>
            <MuiButton className={styles["mui-button"]}>
              {strings.createProject}{" "}
            </MuiButton>
          </Link>
        </div>
      );
    }
  };

  return (
    <Stack className={styles["content-container"]}>
      <div className={styles["notifications"]}>{strings.notifications}</div>
      {/* <div className={styles["tab-switcher"]}>
        <FilledTabSwitcher
          tabvalue={tabValue}
          onChange={handleTabValue}
          tabdata={NotificationTabEnumUtils.getNotificatoinTabEnums()}
        />
      </div> */}
      <Stack
        gap={3}
        sx={{ minHeight: "380px", maxHeight: "400px", overflowY: "scroll" }}
      >
        {renderTabContent(tabValue)}
      </Stack>
    </Stack>
  );
};

export default NotificationContent;
